export default __webpack_public_path__ + "static/media/group_therapy1.4c62563b.png";